/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Unknown_CodeInputs */

const en_issue_unknown_code = /** @type {(inputs: Issue_Unknown_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`does not exist`)
};

/**
* | output |
* | --- |
* | "does not exist" |
*
* @param {Issue_Unknown_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_unknown_code = /** @type {((inputs?: Issue_Unknown_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Unknown_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_unknown_code(inputs)
});